import { useContext } from "react";
import { CookieContext } from "../contexts/CookieContext";

export const useCookieConsent = () => {
  const context = useContext(CookieContext);
  if (context === undefined) {
    throw new Error("useCookieConsent must be used within a CookieProvider");
  }
  return context;
};
